import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide008TemplateFullSessionSummary() {
  return <KbGuidePage slug="guide-008-template-full-session-summary" />;
}

(Guide008TemplateFullSessionSummary as unknown as { path: string }).path = "/automations/template-full-session-summary";
